/**
 * アクセスログ送信サービス
 * 店舗確認表用のアクセスログをAPI経由で非同期送信
 */

import { postRequest } from "./axiosAction";
import { getDeviceType } from "./userLog";

/**
 * アクセスログを非同期で送信する
 * エラーが発生してもメイン処理には影響しない
 * 
 * @param functionName 機能名
 * @param content 内容
 * @param url URL（オプション、指定しない場合は現在のURLを使用）
 * @param applicationName アプリケーション名（オプション、デフォルトは"ofc-counseling"）
 */
export const sendAccessLogAsync = (
  functionName: string,
  content: string,
  url?: string,
  applicationName: string = "ofc-counseling"
): void => {
  // 非同期でアクセスログを送信（fire-and-forget パターン）
  const sendLog = async () => {
    try {
      // 送信パラメータを構築
      const params = {
        device: getDeviceType(),
        function_name: functionName,
        content: content,
        application_name: applicationName,
        url: url || window.location.pathname || ""
      };
      
      // APIエンドポイントURL
      const apiUrl = `${process.env.REACT_APP_API_URL_J11SPB22}/accessLogTenpoCheck/tenpo-accesslog/client`;
      
      // POSTリクエストを送信（axiosActionのpostRequestを使用）
      const response = await postRequest(
        apiUrl,
        params,
        false,  // isLoading: false（ログ送信はバックグラウンド処理）
        true,   // isAuthed: true（認証必要）
        false   // isAuthUpdate: false（トークン更新不要）
      );
      
      // デバッグ用（開発環境のみ）
      if (process.env.NODE_ENV === "development") {
        console.log("アクセスログ送信成功:", {
          functionName,
          content,
          response: response.data
        });
      }
    } catch (error) {
      // ログ送信エラーはコンソールログに記録するのみ
      // メイン処理には影響させない
      console.error("アクセスログ送信エラー:", {
        functionName,
        content,
        error: error
      });
    }
  };
  
  // 非同期実行（awaitなし）
  sendLog();
};

/**
 * 店舗確認
 * DO内個店分析用のアクセスログを送信
 */
export const sendTenpoCheckDoAllStoreAnalysisAccessLog = (): void => {
  sendAccessLogAsync(
    "店舗確認#DO内個店分析",
    "DO内個店分析",
    "",
    "店舗確認"
  );
};

/**
 * 店舗確認
 * DO内個店分析(テンプレート)用のアクセスログを送信
 */
export const sendTenpoCheckDoTemplateAnalysisAccessLog = (): void => {
  sendAccessLogAsync(
    "店舗確認#DO内個店別分析(テンプレート)",
    "DO内個店別分析(テンプレート)",
    "",
    "店舗確認"
  );
};

/**
 * 店舗確認
 * 個店別分析用のアクセスログを送信
 */
export const sendTenpoCheckStoreAnalysisAccessLog = (): void => {
  sendAccessLogAsync(
    "店舗確認#個店別分析",
    "個店別分析",
    "",
    "店舗確認"
  );
};

/**
 * 店舗衛生点検
 * DO内個店分析用のアクセスログを送信
 */
export const sendTSCheckDoAllStoreAnalysisAccessLog = (): void => {
  sendAccessLogAsync(
    "店舗衛生点検#DO内個店分析",
    "DO内個店分析",
    "",
    "店舗衛生点検"
  );
};

/**
 * 店舗衛生点検
 * 個店別分析用のアクセスログを送信
 */
export const sendTSCheckStoreAnalysisAccessLog = (): void => {
  sendAccessLogAsync(
    "店舗衛生点検#個店別分析",
    "個店別分析",
    "",
    "店舗衛生点検"
  );
};

/**
 * OneVision
 * DO内個店分析用のアクセスログを送信
 */
export const sendOneVisionDoAllStoreAnalysisAccessLog = (): void => {
  sendAccessLogAsync(
    "ONEVISION#DO内個店分析",
    "DO内個店分析",
    "",
    "ONEVISION"
  );
};

/**
 * OneVision
 * 個店別分析用のアクセスログを送信
 */
export const sendOneVisionStoreAnalysisAccessLog = (): void => {
  sendAccessLogAsync(
    "ONEVISION#個店別分析",
    "個店別分析",
    "",
    "ONEVISION"
  );
};

/**
 * OneVision（過去）
 * DO内個店分析用のアクセスログを送信
 */
export const sendOneVisionOldDoAllStoreAnalysisAccessLog = (): void => {
  sendAccessLogAsync(
    "ONEVISION(過去)#DO内個店分析",
    "DO内個店分析",
    "",
    "ONEVISION(過去)"
  );
};

/**
 * OneVision（過去）
 * 個店別分析用のアクセスログを送信
 */
export const sendOneVisionOldStoreAnalysisAccessLog = (): void => {
  sendAccessLogAsync(
    "ONEVISION(過去)#個店別分析",
    "個店別分析",
    "",
    "ONEVISION(過去)"
  );
};

/**
 * 店舗経営診断
 * DO内個店分析用のアクセスログを送信
 */
export const sendKeieiShindanDoAllStoreAnalysisAccessLog = (): void => {
  sendAccessLogAsync(
    "店舗経営診断#DO内個店分析",
    "DO内個店分析",
    "",
    "店舗経営診断"
  );
};

/**
 * 店舗経営診断
 * 個店別分析用のアクセスログを送信
 */
export const sendKeieiShindanStoreAnalysisAccessLog = (): void => {
  sendAccessLogAsync(
    "店舗経営診断#個店別分析",
    "個店別分析",
    "",
    "店舗経営診断"
  );
};
